import "./polyfills";

import * as Pages from "./pages";
import GameLogic from "./core/game-logic";

//Pages object
Object.keys(Pages).forEach((key) => Pages[key]());

GameLogic.init();